import { motion } from 'framer-motion';
import { Check, FileText } from 'lucide-react';

import { cn } from '@/lib/utils';

import { Card } from '@/components/ui/card';

import { SourceFileCardProps } from '../types';

export function PipelineSourceCard({
    isUploading,
    progress,
    isComplete,
    fileName,
    fileSize,
}: SourceFileCardProps) {
    return (
        <Card className="p-6 w-full max-w-xs relative overflow-hidden min-h-[200px]">
            <div className="flex flex-col items-center gap-4">
                <div
                    className={cn(
                        'w-16 h-16 rounded-full flex items-center justify-center',
                        isComplete ? 'bg-primary/10' : 'bg-muted',
                    )}
                >
                    <FileText
                        className={cn(
                            'w-8 h-8',
                            isComplete
                                ? 'text-primary'
                                : 'text-muted-foreground',
                        )}
                    />
                </div>

                <div className="text-center space-y-1">
                    <div className="font-semibold">{fileName}</div>
                    <div className="text-sm text-muted-foreground">
                        {fileSize}
                    </div>
                </div>

                {isUploading && (
                    <div className="w-full space-y-2">
                        <div className="h-2 bg-muted rounded-full overflow-hidden">
                            <motion.div
                                className="h-full bg-primary"
                                initial={{ width: 0 }}
                                animate={{ width: `${progress}%` }}
                                transition={{ duration: 0.3 }}
                            />
                        </div>
                        <div className="text-xs text-center text-muted-foreground">
                            Uploading... {Math.round(progress)}%
                        </div>
                    </div>
                )}

                {isComplete && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="flex items-center gap-2 text-sm text-primary"
                    >
                        <Check className="w-4 h-4" />
                        <span>Ready</span>
                    </motion.div>
                )}
            </div>
        </Card>
    );
}
